import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  newName: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmRenameModal: React.FC<Props> = ({
  show,
  newName,
  onChange,
  onClose,
  onConfirm,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onClose}
      className="modal--sm"
      style={{ opacity: 1 }}
    >
      <Modal.Header closeButton>
        <h4>{t("siteManagement.popup.change.siteName")}</h4>
      </Modal.Header>
      <Modal.Body>
        <input
          id="newServiceName"
          name="newServiceName"
          value={newName}
          type="text"
          placeholder={t("siteManagement.popup.change.enterSiteName")}
          className="form-control"
          onChange={onChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-gray" onClick={onClose}>
          {t("common.cancelBtn")}
        </Button>
        <Button className="btn btn-green" onClick={onConfirm}>
          {t("common.okBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmRenameModal;
